module.exports = __webpack_public_path__ + "c127986f1a4aaaa3d1c39b4e5b2ef72a.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/flags/FR.svg
// module id = 522
// module chunks = 74